// @flow
import React, { useState } from 'react';
import i18n from 'i18n-js';
import { MdSignalWifiOff } from 'react-icons/lib/md';

import styles from './busMarker.css';
import { checkNestedObject } from '../../utils';

type BusMarkerPropsType = {
  busCodeName: string,
  tripName: string,
  monitor: any,
  nextStopName: string,
  isOffline: Boolean,
};

const BusMarker = ({
  busCodeName,
  tripName,
  monitor,
  nextStopName,
  isOffline,
}: BusMarkerPropsType) => {
  const [isMouseOver, setIsMouseOver] = useState(false);

  return (
    <div>
      <div
        className={`
          ${isMouseOver ? styles.popupOpen : styles.popupClosed}
          ${styles.markerAndPopupContainer}
        `}
        onMouseLeave={() => setIsMouseOver(false)}
      >
        {isMouseOver
        && (
          <div className={styles.busVirtualPopup}>
            <p className={styles.popupRouteName}>{tripName.length === 16 ? `${tripName.substr(0, 14)}...` : tripName}</p>
            <div className={styles.popupSeparator} />
            <p className={styles.popupGointTo}>{`${i18n.t('common.goingTo')}`}</p>
            <p className={styles.popupDestiny}>{`${nextStopName}`}</p>
            <div className={styles.popupSeparator} />
            <p className={styles.popupMonitor}>{`${i18n.t('labels.monitor.one')}`}</p>
            <div className={styles.busCardMonitorContainer}>
              <img
                className={styles.busCardMonitorImage}
                src={
                  // eslint-disable-next-line no-nested-ternary
                  checkNestedObject(monitor, 'user', 'profile_picture')
                    ? monitor.user.profile_picture
                    : checkNestedObject(monitor, 'profile_picture')
                      ? monitor.profile_picture
                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTez7mpG_Lfb01PnEMjHa4gYPOx7iNTab4KKVnVCdNSGpa1O2RJ'
                }
                alt=""
              />
              <div>
                <p className={styles.busCardMonitorName}>
                  {
                    // eslint-disable-next-line no-nested-ternary
                    checkNestedObject(monitor, 'user', 'first_name')
                      ? monitor.user.first_name
                      : checkNestedObject(monitor, 'first_name')
                        ? monitor.first_name
                        : ''
                  }
                </p>
              </div>
            </div>
          </div>
        )}
        <div
          className={styles.busMarkerContainer}
          onMouseEnter={() => setIsMouseOver(true)}
        >
          <div className={isOffline ? styles.busMarkerPinHeadOffline : styles.busMarkerPinHead}>
            <p className={styles.busMarkerBusName}>
              {isOffline ? <MdSignalWifiOff size={18} /> : null}
              {` ${busCodeName}`}
            </p>
          </div>
          <div className={isOffline ? styles.busMarkerPinOffline : styles.busMarkerPin} />
          <div className={styles.busMarkerShadow} />
        </div>
      </div>
    </div>
  );
};

export default BusMarker;



// WEBPACK FOOTER //
// ./src/scripts/components/BusMarker/index.jsx